import React from 'react'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'

const ResetForm = (
    {
        handleChange,
        handleSubmit,
        inputs,
        isDisable
    }) => {

    return (
        <>
            <Form style={{display: "flex", flexDirection: "column", alignItems: "center"}} onSubmit={handleSubmit}>
                <div className="row form__container form__reset-password">
                    <div className="col-12">
                        <Form.Group>
                        <Form.Label className="form__labels">Email <RequieredInputs/> </Form.Label>
                            <Form.Control
                                className="user-input login"
                                type="email"
                                value={inputs.email}
                                name="email"
                                onChange={handleChange}
                                placeholder="Email"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12">
                        <Form.Group>
                            <Form.Label className="form__labels">Código activación <RequieredInputs/> </Form.Label>
                            <Form.Control className="user-input login"
                                type="password"
                                value={inputs.passCode}
                                name="passCode"
                                onChange={handleChange}
                                placeholder="Código de activación"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12">
                        <Form.Group>
                            <Form.Label className="form__labels">Nueva contraseña <RequieredInputs/> </Form.Label>
                            <Form.Control className="user-input login"
                                type="password"
                                value={inputs.password}
                                name="password"
                                onChange={handleChange}
                                placeholder="Nueva contraseña*"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12">
                        <Form.Group>
                            <Form.Label className="form__labels">Repetir contraseña <RequieredInputs/> </Form.Label>
                            <Form.Control
                                className="user-input login"
                                type="password"
                                value={inputs.repeatPassword}
                                name="repeatPassword"
                                onChange={handleChange}
                                placeholder="Repite la contraseña"
                            />
                        </Form.Group>
                    </div>
                </div>
                <button
                    disabled={isDisable}
                    onClick={handleSubmit}
                    className="btn-landing" size="lg" type="button"
                >
                    GO
                </button>
            </Form>
        </>
    )
}

export default ResetForm